export default {"src":"/_next/static/media/residential2.881a9536.svg","height":72,"width":72,"blurWidth":0,"blurHeight":0};